import get from 'lodash/get';

/* Types */
import { BreakdownItem, Cart } from 'types/cart.types';

/*
 * This bundles up some cart specific data for segment
 * */
export const getCartSegmentProperties = (cart: Cart) => {
  const breakdown = <BreakdownItem>get(cart, 'breakdown', {});
  const items = get(cart, 'items', []);
  const breakdownItems = get(breakdown, 'items', []) || [];
  // try to get partners name from various areas of cart :-(
  const getName = () => cart.partnerName || get(cart, 'partners.name', '') || get(cart, 'partners.landingSeoName', '') || '';
  // try to get additional info by matching in another part of cart
  const getAdditionalItemAttributes = (id: number) => items.find(item => item.skuId === id);

  // partners colate
  const partnerObject = get(cart, 'partner', false);
  const partner = partnerObject
    ? {
        partner_id: partnerObject.id,
        partner_name: getName(),
      }
    : null;

  const products = breakdownItems.map((item: BreakdownItem) => {
    const { skuId } = item;

    return {
      sku_id: skuId,
      base_price: item.amount / 100,
      category: item.category,
      is_remote: get(getAdditionalItemAttributes(skuId), 'remote', false),
      image_url: get(getAdditionalItemAttributes(skuId), 'heroImageUrl', false),
      name: item.name,
      partner,
      physical_product: item.isProduct,
      requires_installation: item.requiresInstallation,
    };
  });

  return {
    cart_id: cart.id,
    amount: breakdown.total / 100,
    savings: breakdown.totalSavings,
    products,
  };
};
